import { ColumnList, ColumnListColumn } from "components/ColumnList"

import { Order } from "../types"

const columns: ColumnListColumn[] = [
    { header: 'Product Name', accessor: 'name', align: 'left', flex: 9 },
    { header: 'Quantity', accessor: 'quantity', align: 'right', flex: 1 },
]

export const Products = ({ order }: { order?: Order }) => {
    if (!order) return null;
    return (
        <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <h2 className="font-medium text-xl text-base-primary">Products</h2>
            <div className="flex flex-col gap-4">
                <ColumnList showColumns columns={columns} data={order?.products.map((product, index) => ({
                    name: product.name,
                    quantity: product.quantity,
                    nameDataTestId: `productsName-${index}`,
                    quantityDataTestId: `productsQuantity-${index}`
                }))} />
            </div>
        </div>
    )
}